// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Config$PorterinUtils from "../configs/Config.mjs";
import * as LocaleConstants$PorterinUtils from "../constants/LocaleConstants.mjs";

function getGaTrackingIdByLocale(locale) {
  if (Js_array.includes(locale, LocaleConstants$PorterinUtils.aeLocales)) {
    return Config$PorterinUtils.ga4_tracking_id_ae;
  } else if (Js_array.includes(locale, LocaleConstants$PorterinUtils.bdLocales)) {
    return Config$PorterinUtils.ga4_tracking_id_bd;
  } else if (Js_array.includes(locale, LocaleConstants$PorterinUtils.trLocales)) {
    return Config$PorterinUtils.ga4_tracking_id_tr;
  } else {
    return Config$PorterinUtils.ga4_tracking_id_dom;
  }
}

export {
  getGaTrackingIdByLocale ,
}
/* Config-PorterinUtils Not a pure module */
